<template>
    <h1 class="mb-3"><span class="text-blue">Laporan</span> <span class="text-red">Kegiatan</span></h1>
     <div class="tables">
    <tables>
        <template v-slot:first> No.</template>
        <template v-slot:second>Kegiatan </template>
        <template v-slot:third>Tanggal Ikut </template>
        <template v-slot:fourth>Sertifikat</template>
    </tables>
     </div>
     <div class="listPengajuan">
            <div class="card">
                <div>Kegiatan</div>
                <div class="text-bold">Pembekalan Caleg & Konsolidasi Daerah Jawa Barat 2021</div>
                <div>Tanggal Ikut</div>
                <div class="text-bold">10 Juni 2021</div>
                <div>Sertifikat</div>
                <a href="#" target="blank"><div>Download</div></a>
            </div>
              <button class="btnSelengkapnya">Lihat Lebih Banyak <i class="fas fa-chevron-down"></i></button>
     </div>
</template>
<script>
import tables from '../../components/table.vue'
export default {
  components: {
    tables
  }
}
</script>
<style lang="scss" scoped>
  h1 {
        @media only screen and (max-width: 600px) {
            font-size: 16px;
            margin-bottom: 2rem !important;
            margin-top: 2rem;
        }
    }

    .card{
        box-shadow: 0 9.7px 0 0 rgba(33, 64, 154, 0.03), 0 33px 67px 0 rgba(33, 64, 154, 0.08);
    }

    a{
        color: #21409a;
    }
</style>
